import { Message } from "element-ui";

class DataAuth {
    /**
     * 校验邮箱格式
     * @param {string} email - 待校验的邮箱地址
     * @returns {boolean} - 如果邮箱格式有效返回 true，否则返回 false
     */
    static validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    /**
     * 校验密码强度
     * 密码要求：至少 8 个字符，包含字母和数字
     * @param {string} password - 待校验的密码
     * @returns {boolean} - 如果密码符合要求返回 true，否则返回 false
     */
    static validatePassword(password) {
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,12}$/;
        return passwordRegex.test(password);
    }

    static validateResp(resp) {
        if (resp === undefined || resp === null) {
            Message.error("请求失败!");
        } else {
            const { code, msg } = resp;
            if (code != 200) {
                Message.error(msg);
            } else {
                Message.success("操作成功");
            }
        }
        window.location.reload();
    }

}

// 导出 DataAuth 工具类
export default DataAuth;